import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/travis/build/GogoWwz/TMagic/node_modules/gatsby-theme-docz/src/base/Layout.js";
import './styles/index.scss';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "tmagic"
    }}>{`TMagic`}</h1>
    <p>{`一个简单、轻量的React组件库`}</p>
    <h3 {...{
      "id": "安装"
    }}>{`安装`}</h3>
    <p><inlineCode parentName="p">{`npm install tmagic`}</inlineCode></p>
    <h3 {...{
      "id": "引入样式"
    }}>{`引入样式`}</h3>
    <p><inlineCode parentName="p">{`import "tmagic/dist/index.css"`}</inlineCode></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      